import { useCustomSWR } from 'hooks/useCustomSWR';
import { apiUrls } from 'services/api-urls';
import { fetcher } from 'services/fetcher';
import { ProductSymfony } from 'types/Product';

export default function useProductInfos(
  sku: string,
  reference: string,
  size: string
): UseProductInfosType {
  const { data: productInfos } = useCustomSWR<ProductSymfony>(
    apiUrls.getProductInfos(sku, reference, size),
    fetcher
  );

  return { productInfos };
}

type UseProductInfosType = { productInfos?: ProductSymfony };
